const myTransactions = {
  selectDateRage:'Seleccionar rango de fechas',
  selectTransactionType:'Seleccionar tipo de transacción',
  selectApplication:'Seleccionar aplicación',
  export:'Exportar',
  myTransactions: 'Mis transacciones',
  showing: 'Mostrando',
  transactionsOf: 'Transacciones de',
  noTransactionsFound: 'No se encontraron transacciones',
};

export default myTransactions;
